<div class="flex justify-center items-center w-full h-screen bg-surface-50">
  <div class="flex flex-col items-center">
    <pfx-sign-in></pfx-sign-in>

    @if (!authenticationStore.isPending() && !authenticationStore.isAuthenticated()) {
      <pfx-button
        class="mt-6"
        [title]="'become_partner' | i18next: { ns: 'login-view' }"
        severity="basic"
        [routerLink]="['..', 'register', 'partner']"
      ></pfx-button>
    }
  </div>
</div>
